import { SectionHeader } from "./Field";
import { Lock } from "lucide-react";

function Row({ label, value }) {
  return (
    <div className="flex items-start justify-between gap-6 py-3 border-b border-[#E8DCC8]/60">
      <span className="text-xs uppercase tracking-widest text-[#8B8378] shrink-0 pt-0.5">
        {label}
      </span>
      <span className="text-sm text-[#3A342E] text-right max-w-[65%] break-words">
        {value || "—"}
      </span>
    </div>
  );
}

export default function StepReview({ form }) {
  const r1 = form.reference_1, r2 = form.reference_2, r3 = form.reference_3;
  return (
    <div>
      <SectionHeader
        eyebrow="Final Step"
        title="Review & submit."
        description="A final glance. Payment of $50 is processed securely by Stripe."
      />

      <div className="rounded-sm border border-[#E8DCC8] bg-white p-6 md:p-8">
        <p className="label-eyebrow mb-4 text-[#A67C2E]">Property</p>
        <Row label="Applying For" value={form.property_applying_for} />
        <Row label="Lease Length" value={`${form.lease_length_months} months`} />
        <Row label="Preferred Move-in" value={form.preferred_move_in_date} />

        <p className="label-eyebrow mt-8 mb-4 text-[#A67C2E]">Personal</p>
        <Row label="Name" value={form.full_name} />
        <Row label="Email" value={form.email} />
        <Row label="Phone" value={form.phone} />
        <Row label="Date of Birth" value={form.date_of_birth} />
        <Row label="Adults" value={form.number_of_adults} />
        <Row label="Pets" value={form.has_pets ? `Yes — ${form.pet_breeds || "unspecified"}` : "No"} />

        <p className="label-eyebrow mt-8 mb-4 text-[#A67C2E]">Residence</p>
        <Row label="Address" value={form.current_address} />
        <Row label="Landlord Phone" value={form.current_landlord_phone} />
        <Row label="Years" value={form.years_at_current_address} />

        <p className="label-eyebrow mt-8 mb-4 text-[#A67C2E]">Employment</p>
        <Row label="Occupation" value={form.occupation} />
        <Row label="Job Title" value={form.job_title} />
        <Row label="Supervisor" value={`${form.supervisor_name} — ${form.supervisor_phone}`} />
        <Row label="Monthly Income" value={form.monthly_income ? `$${Number(form.monthly_income).toLocaleString()}` : ""} />

        <p className="label-eyebrow mt-8 mb-4 text-[#A67C2E]">References</p>
        <Row label="Ref. 1" value={`${r1.name} · ${r1.phone} · ${r1.relation}`} />
        <Row label="Ref. 2" value={`${r2.name} · ${r2.phone} · ${r2.relation}`} />
        <Row label="Ref. 3" value={`${r3.name} · ${r3.phone} · ${r3.relation}`} />

        <p className="label-eyebrow mt-8 mb-4 text-[#A67C2E]">Background</p>
        <Row label="Felony (7yr)" value={form.convicted_felony_7yrs ? "Yes" : "No"} />
        {form.convicted_felony_7yrs && (
          <Row label="Felony Explanation" value={form.felony_explanation} />
        )}
        <Row label="Prior Eviction" value={form.evicted_or_asked_to_vacate ? "Yes" : "No"} />
        {form.evicted_or_asked_to_vacate && (
          <Row label="Explanation" value={form.eviction_explanation} />
        )}
        <Row
          label="Certification"
          value={
            form.certification_agreed
              ? "Signed — authorized background check & reference contact"
              : "Not signed"
          }
        />
      </div>

      {/* Payment summary card */}
      <div className="mt-8 rounded-sm border border-[#A67C2E]/35 bg-gradient-to-b from-[#A67C2E]/[0.07] to-transparent p-6 md:p-8">
        <div className="flex items-start justify-between gap-6">
          <div>
            <p className="label-eyebrow text-[#A67C2E] mb-2">Application Processing Fee</p>
            <p className="font-heading text-3xl mb-2">$50.00 USD</p>
            <p className="text-sm text-[#6B6560] max-w-md">
              One-time, non-refundable processing fee. Includes background review and
              reference verification.
            </p>
          </div>
          <div className="hidden sm:flex items-center gap-2 text-xs text-[#8B8378] shrink-0">
            <Lock className="w-3.5 h-3.5" /> Stripe Secure
          </div>
        </div>
      </div>

      {/* EO housing footer */}
      <p
        className="mt-6 text-[11px] text-[#8B8378] leading-relaxed"
        data-testid="review-eo-housing"
      >
        Experian Properties is an Equal Opportunity Housing provider. All information
        is held in strict confidence and used solely to evaluate this application.
      </p>
    </div>
  );
}
